import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d6d6d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coaching-topic-animation-container" }
const _hoisted_2 = { class: "coaching-topic-container" }
const _hoisted_3 = { class: "coaching-topic-team-member-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Team", -1))
const _hoisted_5 = { class: "coaching-topic-team-member-selected-option" }
const _hoisted_6 = { class: "slider" }
const _hoisted_7 = { class: "slider-container" }
const _hoisted_8 = { class: "coaching-topic-feedback-container" }
const _hoisted_9 = { class: "coaching-topic-feedback-container" }
const _hoisted_10 = {
  key: 1,
  class: "loading"
}
const _hoisted_11 = { class: "coaching-topic-sort-modal" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TwoLineHeader = _resolveComponent("TwoLineHeader")!
  const _component_InsightsTimePickerMobile = _resolveComponent("InsightsTimePickerMobile")!
  const _component_Lottie = _resolveComponent("Lottie")!
  const _component_TopicCard = _resolveComponent("TopicCard")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TeamMemberTileMobile = _resolveComponent("TeamMemberTileMobile")!
  const _component_InsightsCoachingTopicReviews = _resolveComponent("InsightsCoachingTopicReviews")!
  const _component_SimpleSpinner = _resolveComponent("SimpleSpinner")!
  const _component_Scrollable = _resolveComponent("Scrollable")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_ctx.topicData)
    ? (_openBlock(), _createBlock(_component_WebViewScreen, {
        key: 0,
        "no-pad": "",
        "disable-when-offline": "",
        "show-go-back": ""
      }, {
        "custom-title": _withCtx(() => [
          _createVNode(_component_TwoLineHeader, {
            title: `Coaching - ${_ctx.topic}`,
            subtitle: _ctx.friendlyTimeRange
          }, null, 8, ["title", "subtitle"])
        ]),
        "right-button": _withCtx(() => [
          _createVNode(_component_InsightsTimePickerMobile, {
            "time-range": _ctx.timeRange,
            onSelectTime: _ctx.updateTimeRange
          }, null, 8, ["time-range", "onSelectTime"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Scrollable, null, {
            default: _withCtx(() => [
              (_ctx.insightsCoaching)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, [
                      (_ctx.animationData)
                        ? (_openBlock(), _createBlock(_component_Lottie, {
                            key: 0,
                            "class-name": "bg-img-container",
                            "animation-data": _ctx.animationData
                          }, null, 8, ["animation-data"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_TopicCard, {
                        "question-type": _ctx.insightsCoaching.question_type,
                        data: _ctx.topicData,
                        "total-topic-response-count": _ctx.totalTopicResponseCount
                      }, null, 8, ["question-type", "data", "total-topic-response-count"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: "coaching-topic-team-member-sort",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTeamSortModal = true))
                      }, [
                        _hoisted_4,
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedSortOption), 1),
                        _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faChevronDown }, null, 8, ["icon"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (teamMemberData, name) => {
                            return (_openBlock(), _createBlock(_component_TeamMemberTileMobile, {
                              key: name,
                              name: name,
                              data: teamMemberData,
                              topic: _ctx.topic,
                              badge: _ctx.topicData.badge,
                              width: 150,
                              height: 186,
                              class: "coaching-topic-team-member-tile"
                            }, null, 8, ["name", "data", "topic", "badge"]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_InsightsCoachingTopicReviews, {
                        title: _ctx.getCoachingResponseTitle(true),
                        responses: _ctx.getCoachingResponses(true, 2),
                        "show-more-router-link": {
                            name: 'InsightsCoachingTopicFeedback',
                            params: { topic: _ctx.topic, feedbackType: 'Positive' },
                        }
                      }, null, 8, ["title", "responses", "show-more-router-link"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_InsightsCoachingTopicReviews, {
                        title: _ctx.getCoachingResponseTitle(false),
                        responses: _ctx.getCoachingResponses(false, 2),
                        "show-more-router-link": {
                            name: 'InsightsCoachingTopicFeedback',
                            params: { topic: _ctx.topic, feedbackType: 'Negative' },
                        }
                      }, null, 8, ["title", "responses", "show-more-router-link"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_SimpleSpinner, {
                      size: "small",
                      class: "spinner",
                      "line-fg-color": "#B338A3"
                    })
                  ]))
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Modal, {
              top: 25,
              show: _ctx.showTeamSortModal,
              "allow-click-out": "",
              "allow-escape": "",
              "has-close": false,
              title: "View Results By:",
              size: "medium",
              close: () => (_ctx.showTeamSortModal = false),
              "visible-if-overflow": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sortOption, sortOptionIdx) => {
                  return (_openBlock(), _createElementBlock("div", { key: sortOptionIdx }, [
                    _createElementVNode("div", {
                      class: "coaching-topic-sort-option",
                      onClick: ($event: any) => (_ctx.selectSortOption(sortOption))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                                active: sortOption === _ctx.selectedSortOption,
                            })
                      }, _toDisplayString(sortOption), 3),
                      _createElementVNode("div", null, [
                        (sortOption === _ctx.selectedSortOption)
                          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                              key: 0,
                              icon: _ctx.faCheck,
                              class: "active"
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_12)
                  ]))
                }), 128))
              ], undefined, true),
              _: 1
            }, 8, ["show", "close"])
          ])
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}